const COARSE_POINTER_QUERY = '(any-pointer: coarse)'

let cached: { matchMedia: typeof window.matchMedia; list: MediaQueryList } | undefined

/**
 * One `MediaQueryList` shared by every subscriber, created on first use in the browser. Replacing
 * `window.matchMedia` (as tests do to mock pointer capabilities) resets it.
 */
export function getCoarsePointerQuery() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null
  if (cached?.matchMedia !== window.matchMedia) {
    cached = { matchMedia: window.matchMedia, list: window.matchMedia(COARSE_POINTER_QUERY) }
  }
  return cached.list
}
